var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[_c('v-icon',{staticClass:"current-color",style:('background-color:' + _vm.$options.methods.getColorCode(_vm.props.item.color)),attrs:{"align-center":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }